import { inject } from '@angular/core';
import { CanActivateFn, PRIMARY_OUTLET, Router } from '@angular/router';
import { AuthContextService } from '@common/services';

export const autoRedirectToAuthUserGuard = (basePath: string): CanActivateFn => {
  return (_, state) => {
    const authContext = inject(AuthContextService);
    const router = inject(Router);

    const defaultId = authContext.id();

    if (!defaultId) {
      return true;
    }

    const urlTree = router.parseUrl(state.url);
    const segments = urlTree.root.children[PRIMARY_OUTLET]?.segments ?? [];

    if (segments.length === 0) {
      return true;
    }

    const lastSegment = segments[segments.length - 1].path;

    if (lastSegment !== basePath) {
      return true;
    }

    const newPath = ['/', ...segments.map((s) => s.path), defaultId];

    return router.createUrlTree(newPath, {
      queryParams: urlTree.queryParams,
      fragment: urlTree.fragment
    });
  };
};
